// extracted by mini-css-extract-plugin
module.exports = {"vertical":"Divider_vertical__NmD7r","horizontal":"Divider_horizontal__Pwm5c"};